// TransparencySection.js
import React from 'react';
import { motion } from 'framer-motion';
import { Shield, DollarSign, FileCheck } from 'lucide-react';

const TransparencySection = () => {
  const transparencyPoints = [
    {
      icon: DollarSign,
      title: 'No Salary Collection',
      description: 'Notapaths does not collect salaries or employer related fees'
    },
    {
      icon: FileCheck,
      title: 'Direct Employment Contracts',
      description: 'Employment contracts are between candidates and employers'
    },
    {
      icon: Shield,
      title: 'Professional Support Services',
      description: 'Our fees cover professional support services only'
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl md:text-4xl font-semibold text-[#202356] mb-4">
            Transparency and Payments
          </h2>
          <p className="text-gray-600 text-sm font-light max-w-2xl mx-auto">
            We operate with full transparency
          </p>
        </motion.div>

        {/* Transparency Points Grid */}
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          {transparencyPoints.map((point, index) => {
            const Icon = point.icon;
            return (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: index * 0.1 }}
                className="text-center"
              >
                <div className="inline-flex items-center justify-center w-16 h-16 bg-[#F5F8FA] rounded-full mb-4">
                  <Icon size={28} className="text-[#202356]" />
                </div>
                <h3 className="text-lg font-semibold text-[#202356] mb-2">
                  {point.title}
                </h3>
                <p className="text-gray-600 text-sm font-light">
                  {point.description}
                </p>
              </motion.div>
            );
          })}
        </div>

        {/* Additional Info Box */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="bg-[#F5F8FA] p-8 rounded-lg max-w-4xl mx-auto"
        >
          <p className="text-gray-700 text-sm font-light leading-relaxed text-center">
            Any employment related payments are handled directly with employers or relevant authorities. Our fees cover professional support services only.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default TransparencySection;
